import { render, staticRenderFns } from "./BlocksDragItems.vue?vue&type=template&id=75a2255c"
import script from "./BlocksDragItems.vue?vue&type=script&lang=js"
export * from "./BlocksDragItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports